var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolidity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_solidity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.477,2l-4.5,8h-9l4.5-8h9",
    style: {
      fill: "#c1c1c1",
      opacity: 0.45,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.52,30l4.5-8h9l-4.5,8h-9",
    style: {
      fill: "#c1c1c1",
      opacity: 0.45,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.975,10h9l-4.5-8h-9Z",
    style: {
      fill: "#c1c1c1",
      opacity: 0.6,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.022,22h-9l4.5,8h9Z",
    style: {
      fill: "#c1c1c1",
      opacity: 0.6,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.477,18l4.5-8-4.5-8-4.5,8Z",
    style: {
      fill: "#c1c1c1",
      opacity: 0.8,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.52,14l-4.5,8,4.5,8,4.5-8Z",
    style: {
      fill: "#c1c1c1",
      opacity: 0.8,
      isolation: "isolate"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidity);
export default __webpack_public_path__ + "static/media/solidity.2bd035789524bdc0a68a28510dc9eceb.svg";
export { ForwardRef as ReactComponent };